<template>
  <div class="member-progress-viewer-content w-full h-full">
    <vs-row class="pb-12">
      <vs-col v-for="(styleTag, index) in styleContent" :key="index" :class="{ 'pb-3': hasBottomPadding(index) }">
        <div :class="[{'px-5': !isBanner(styleTag), 'pt-5': index === 0 && !isBanner(styleTag)}, styleTag.additionalclasses]">
          <template v-if="styleTag.key === 'content'">
            <slot></slot>
          </template>

          <template v-else>
            <member-progress-viewer-graphic v-if="styleTag.key === 'graphic'" :style-tag="styleTag" :session-resource="sessionResource"></member-progress-viewer-graphic>

            <h1 v-else-if="styleTag.key === 'h1'" class="starling-h1" v-html="styleTag.content"></h1>
            <h2 v-else-if="styleTag.key === 'h2'" class="starling-h2" v-html="styleTag.content"></h2>
            <h3 v-else-if="styleTag.key === 'h3'" class="starling-h3" v-html="styleTag.content"></h3>
            <h4 v-else-if="styleTag.key === 'h4'" class="starling-h4" v-html="styleTag.content"></h4>
            <h5 v-else-if="styleTag.key === 'h5'" class="starling-h5" v-html="styleTag.content"></h5>
            <p v-else-if="styleTag.key === 'body'" class="starling-body" v-html="styleTag.content"></p>
            <p v-else-if="styleTag.key === 'citation'" class="starling-citation" v-html="styleTag.content"></p>
            <p v-else-if="styleTag.key === 'explanatory'" class="starling-explanatory" v-html="styleTag.content"></p>
            <p v-else-if="styleTag.key === 'instructional'" class="starling-instructional" v-html="styleTag.content"></p>
            <p v-else-if="styleTag.key === 'text'" class="starling-text" v-html="styleTag.content"></p>
          </template>
        </div>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import MemberProgressViewerGraphic from '@/views/app/view_member/progress/member-progress-viewer-graphic';

const knownClasses = [
  { name: 'h1', isHeader: true },
  { name: 'h2', isHeader: true },
  { name: 'h3', isHeader: true },
  { name: 'h4', isHeader: true },
  { name: 'h5', isHeader: true },
  { name: 'body', isHeader: false },
  { name: 'citation', isHeader: false },
  { name: 'explanatory', isHeader: false },
  { name: 'instructional', isHeader: false },
  { name: 'text', isHeader: false },
  { name: 'graphic', isHeader: false }
];

export default {
  name: 'member-progress-viewer-content',
  components: { MemberProgressViewerGraphic },
  props: {
    sessionResource: ResourceImpl
  },
  data () {
    return {
      styleContent: null
    };
  },
  mounted () {
    if (!this.sessionResource.styleContent || !this.sessionResource.styleContent.length || (this.sessionResource.styleContent.length === 1 && this.sessionResource.styleContent[0].key === 'content')) {
      this.styleContent = [
        { key: 'h3', content: this.sessionResource.title},
        { key: 'content', content: ''}
      ];
    } else {
      this.styleContent = this.sessionResource.styleContent;
    }
  },
  methods: {
    hasBottomPadding (index) {
      if (index >= this.styleContent.length - 1) return false;

      const currentTag = this.styleContent[parseInt(index)];
      if (knownClasses.findIndex(classe => classe.name === currentTag.key) < 0) return false;

      const nextTag = this.styleContent[index + 1];
      const headerClasses = knownClasses.filter(classe => !!classe.isHeader);
      if (headerClasses.some(classe => classe.name === currentTag.key) && headerClasses.some(classe => classe.name === nextTag.key)) return false;

      if (currentTag.key === 'h5' && nextTag.key === 'body') return false;
      return currentTag.key !== 'graphic' && nextTag.key !== 'graphic';
    },
    isBanner (tag) {
      return tag.key === 'graphic' && tag.size === 'xl' && tag.vertical === 'top';
    }
  }
};
</script>
